module.exports = __webpack_public_path__ + "img/qatar.d01c44d8.svg";